module.exports = __webpack_public_path__ + "static/media/tulleord-norming-tutorial-1.8e12c06b.mp3";